import { style } from 'typestyle';

export const styles = style({
  display: 'grid',
  gridTemplateAreas: `
    'collection divider analysis'
  `,
  gridTemplateRows: '100%',
  gridTemplateColumns: '24% 1% 75%',
  height: '100%',
  width: '100%',
  $nest: {
    '& > [data-qa="Subheader"]': {},
    '& .collection-info': {
      gridArea: 'collection',
      display: 'flex',
      flexDirection: 'column',
      padding: '0 1rem',
      rowGap: '1rem',
      $nest: {
        '& .collection-header': {
          $nest: {
            '& [data-qa="collection-analysis-name"] + div + div, & [data-qa="collection-analysis-description"] + div + div':
              {
                marginBottom: 0,
              },
            '& [data-qa="collection-analysis-name"] .form-control, & [data-qa="collection-analysis-description"] .form-control':
              {
                height: 'initial',
                lineHeight: 'initial',
                padding: 'initial',
                margin: '5px 0px',
                width: 'calc(100% - 10px)', // 10px of margin total from wrapper component in InputGeneric
              },
          },
        },
        '& .collection-metrics': {
          $nest: {
            '.metric-header': {
              fontWeight: '700',
              fontSize: '0.8rem',
              marginRight: '0.5rem',
            },
            '.metric-value': {
              fontSize: '0.75rem',
            },
          },
        },
        img: {
          objectFit: 'contain',
          width: '100%',
          height: '50%',
        },
        '& header.items-header': {
          display: 'flex',
          alignItems: 'flex-end',
          fontWeight: '600',
        },
        '.detail-cards': {
          display: 'flex',
          width: '100%',
          overflowX: 'auto',
          flex: 1,
          $nest: {
            'img:first-of-type': {
              marginLeft: 0,
            },
            img: {
              height: '100%',
              margin: '0 0.75rem',
            },
            '& .no-data': {
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              fontSize: '13px',
              alignItems: 'center',
            },
          },
        },
      },
    },
    '& .divider': {
      gridArea: 'divider',
    },
    '& .analysis-info': {
      gridArea: 'analysis',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '1.5rem',
      $nest: {
        '.macros': {},
        '[data-qa="key-financials"]': {
          flexWrap: 'wrap',
        },
        '.key-financial-item': {
          width: 'auto',
          padding: '0.5rem 1rem',
        },
        '.analysis-grid': {
          display: 'flex',
          flex: 1,
          $nest: {
            // FIXME: there has to be a better way than duping these all
            '& .s5-MuiAccordion-root.Mui-expanded': {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            },
            '& .s5-MuiCollapse-entered': {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            },
            '& .s5-MuiCollapse-wrapper': {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            },
            '& .s5-MuiCollapse-wrapperInner': {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            },
            '& .s5-MuiCollapse-wrapperInner > div[role="region"]': {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
            },
            '[data-qa="editable-grid-container"]': {
              flex: 1,
              width: '100%',
            },
          },
        },
      },
    },
  },
});
